export enum EmailMethod {
	DEFAULT = "default",
	GMAIL = "gmail",
	MICROSOFT = "microsoft"
}


export class MailSettings {
	ID:number = 0;
	Label:string  = "New mail settings" // TODO: Change default name
	Email: string = "";
	EmailPassword: string = "";
	EmailServer: string = "";
	EmailFrom: string = "";
	EmailName: string = "";
	DefaultCCEmail:string = "";
	DefaultBCCEmail:string = "";
	EmailMethod:EmailMethod = EmailMethod.DEFAULT;
	Signature:string = "";
	InsecureSkipVerify:boolean = false;
	IsDefault:boolean = false;
	UserID:number = 0;

	constructor(data?: any) {
		if (!data) return;
		this.ID = data.ID;
		this.Label = data.Label;
		this.Email = data.Email;
		this.EmailServer = data.EmailServer;
		this.EmailFrom = data.EmailFrom;
		this.EmailName = data.EmailName;
		this.DefaultCCEmail = data.DefaultCCEmail;
		this.DefaultBCCEmail = data.DefaultBCCEmail;
		this.EmailMethod = data.EmailMethod;
		this.Signature = data.Signature;
		this.InsecureSkipVerify = data.InsecureSkipVerify;
		this.IsDefault = data.IsDefault || false;
		this.UserID = data.UserID;
	}

	getJSON(): any {
		return {
			ID: this.ID,
			Label: this.Label,
			Email: this.Email,
			EmailPassword: this.EmailPassword,
			EmailServer: this.EmailServer,
			EmailFrom: this.EmailFrom,
			EmailName: this.EmailName,
			DefaultCCEmail: this.DefaultCCEmail,
			DefaultBCCEmail: this.DefaultBCCEmail,
			Signature: this.Signature,
			InsecureSkipVerify: this.InsecureSkipVerify
		};
	}
}